/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import ObjectType from './ObjectType';
import MoserObject from './MoserObject';
import SqlLanguageType from './SqlLanguageType';
//@import com/ibm/bi/platform/moser/common/generated/metadata/ObjectType (loadtime) // superclass
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (static) // fromJSONHelper
//@import com/ibm/bi/platform/moser/common/generated/metadata/SqlLanguageType (runtime) // new

/**
 * Defines a query against the specified database. <p>Java class for sqlQueryType complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="sqlQueryType"&gt; &lt;complexContent&gt; &lt;extension base="{}objectType"&gt; &lt;sequence&gt; &lt;element name="datasourceRef" type="{http://www.w3.org/2001/XMLSchema}string" maxOccurs="unbounded"/&gt; &lt;element name="sqlText" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="sqlType" type="{}sqlLanguageType" minOccurs="0"/&gt; &lt;element name="projectedItem" type="{}projectedItemType" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
export default class SqlQueryType extends ObjectType{

	datasourceRef = null;

	sqlText = null;

	sqlType = null;

	projectedItem = null;



	/**
	 * Gets the value of the datasourceRef property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the datasourceRef property. <p> For example, to add a new item, do as follows: <pre> getDatasourceRef().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link String}
	 */
	getDatasourceRef() {
		if (!this.datasourceRef) {
			this.datasourceRef = [];
		}
		return this.datasourceRef;
	}

	/**
	 * Gets the value of the sqlText property.
	 * @return {String} possible object is {@link String}
	 */
	getSqlText() {
		return this.sqlText;
	}

	/**
	 * Sets the value of the sqlText property.
	 * @param {String} value allowed object is {@link String}
	 */
	setSqlText(value) {
		var oldValue = this.sqlText;
		this.sqlText = value;
		this._setAndNotify(171, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the sqlType property.
	 * @return {SqlLanguageType} possible object is {@link SqlLanguageType}
	 */
	getSqlType() {
		return this.sqlType;
	}

	/**
	 * Sets the value of the sqlType property.
	 * @param {SqlLanguageType} value allowed object is {@link SqlLanguageType}
	 */
	setSqlType(value) {
		var oldValue = this.sqlType;
		this.sqlType = value;
		this._setAndNotify(172, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the projectedItem property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the projectedItem property. <p> For example, to add a new item, do as follows: <pre> getProjectedItem().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link ProjectedItemType}
	 */
	getProjectedItem() {
		if (!this.projectedItem) {
			this.projectedItem = [];
		}
		return this.projectedItem;
	}

	/**
	 * Gets the value of the <code>datasourceRef</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>String</code> elements, or <code>null</code> if not set
	 */
	basicGetDatasourceRef() {
		return this.datasourceRef;
	}

	/**
	 * Gets the value of the <code>projectedItem</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>ProjectedItemType</code> elements, or <code>null</code> if not set
	 */
	basicGetProjectedItem() {
		return this.projectedItem;
	}

	/**
	 * Creates a new instance of <code>SqlQueryType</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> SqlQueryType</code> object from.
	 * @return {SqlQueryType} an object of type <code>SqlQueryType</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createSqlQueryType();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addDatasourceRefAt(position, item) {
		this._addAtAndNotify(this.getDatasourceRef(), position, item, 170, false, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addDatasourceRef(item) {
		this.addDatasourceRefAt(this.getDatasourceRef().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeDatasourceRefAt(position) {
		this._removeAtAndNotify(this.getDatasourceRef(), position, 170, false);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeDatasourceRef(item) {
		var i = this.getDatasourceRef().indexOf(item);
		if (i >= 0) {
			this.removeDatasourceRefAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addProjectedItemAt(position, item) {
		this._addAtAndNotify(this.getProjectedItem(), position, item, 173, true, true);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addProjectedItem(item) {
		this.addProjectedItemAt(this.getProjectedItem().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeProjectedItemAt(position) {
		this._removeAtAndNotify(this.getProjectedItem(), position, 173, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeProjectedItem(item) {
		var i = this.getProjectedItem().indexOf(item);
		if (i >= 0) {
			this.removeProjectedItemAt(i);
		}
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "SqlQueryType";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(true, false, false, 170, "datasourceRef", null));
		featureList.push(this.createFeature(false, false, false, 171, "sqlText", null));
		featureList.push(this.createFeature(false, true, false, 172, "sqlType", SqlLanguageType));
		var clazz;
		if (factory) {
			clazz = factory.createProjectedItemType().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 173, "projectedItem", clazz));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 171:
			this.setSqlText((value));
			break;
		case 172:
			this.setSqlType((value));
			break;
		default:
			super.set(featureID, value);
		}
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set the value to set
	 * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	 */
	_setList(featureID, value) {
		switch (featureID) {
		case 170:
			this.datasourceRef = (value);
			break;
		case 173:
			this.projectedItem = (value);
			break;
		default:
			super._setList(featureID, value);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 170:
			return this.getDatasourceRef();
		case 171:
			return this.getSqlText();
		case 172:
			return this.getSqlType();
		case 173:
			return this.getProjectedItem();
		default:
			return super.get(featureID);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 170:
			return this.basicGetDatasourceRef();
		case 171:
			return this.getSqlText();
		case 172:
			return this.getSqlType();
		case 173:
			return this.basicGetProjectedItem();
		default:
			return super.basicGet(featureID);
		}
	}

	/**
	 * Add the value of a specific feature at a specific position
	 * @param {int} position the array position of the item to be added
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	addAt(featureID, position, value) {
		switch (featureID) {
		case 170:
			this.addDatasourceRefAt(position, (value));
			break;
		case 173:
			this.addProjectedItemAt(position, (value));
			break;
		default:
			super.addAt(featureID, position, value);
		}
	}

	/**
	 * Add the value to the end of a specific collection feature
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	add(featureID, value) {
		switch (featureID) {
		case 170:
			this.addDatasourceRef((value));
			break;
		case 173:
			this.addProjectedItem((value));
			break;
		default:
			super.add(featureID, value);
		}
	}

	/**
	 * Remove the value of a specific feature by index.
	 * @param {int} position the array position of the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	removeAt(featureID, position) {
		switch (featureID) {
		case 170:
			this.removeDatasourceRefAt(position);
			break;
		case 173:
			this.removeProjectedItemAt(position);
			break;
		default:
			super.removeAt(featureID, position);
		}
	}

	/**
	 * Remove the value from specific feature.
	 * @param {BaseMoserObject} item the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	remove(featureID, item) {
		switch (featureID) {
		case 170:
			this.removeDatasourceRef((item));
			break;
		case 173:
			this.removeProjectedItem((item));
			break;
		default:
			super.remove(featureID, item);
		}
	}
}


// WEBPACK FOOTER //
// ./src/generated/SqlQueryType.js